<div class="follow-btn-container">
    <p-toggleButton [(ngModel)]="isFollowed" (click)="$event.preventDefault(); $event.stopPropagation();interact()" onLabel="Following" offLabel="Follow" />
</div>